// import React from "react";
import { Route, Routes } from "react-router-dom";

import { useDocument } from "../../../../firebase-files/hooks/useDocument";
import PlantationOneFooter from "../plantationOneComponents/PlantationOneFooter";
import Navbar from "../../../../default-components/Navbar";
import PGAboutUs from "../../../../default-pages/about us/PGAboutUs";
import PlantationOneHome from "../../../environment/environmentOne/plantationOnePages/PlantationOneHome";
import BusinessThreeNavbar from "../../../business/businessThree/businessThreeComponents/BusinessThreeNavbar";
import GlobalRoute from "../../../../global route/GlobalRoute";
import PlantationOneDashboard from "../plantationOnePages/PlantationOneDashboard";
import AdoptedTreeDetails from "../plantationOnePages/AdoptedTreeDetails";
import "../plantationOneCss/PlantationOneColor.scss";
import "../plantationOneCss/PlantationOneFont.scss";
// import '../plantationOneCss/PlantationOneStyle.scss'
import "../plantationOneCss/PlantationOneStyleOne.scss";
import FooterUpper from "../../../../default-components/FooterUpper";

const PlantationOneRoute = () => {
  const { document: navTypeDoc } = useDocument("settings", "navbarType");
  return (
    <div className="plantation_one_route_parent">
      {navTypeDoc && navTypeDoc.activeNav === "FixNav" ? (
        <Navbar />
      ) : (
        <BusinessThreeNavbar />
      )}

      <Routes>
        <Route path="/" element={<PlantationOneHome />} />
        {/* <Route path="/aboutus" element={<PGAboutUs />} /> */}
        <Route path="/my-plants" element={<PlantationOneDashboard />} />
        <Route
          path="/my-plants/:orderId/:slug/:plantId"
          element={<AdoptedTreeDetails />}
        />
      </Routes>
      <GlobalRoute />
      <FooterUpper/>
      <PlantationOneFooter />
    </div>
  );
};

export default PlantationOneRoute;
